var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path27, _path28, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _rect24, _rect25, _rect26, _rect27, _rect28, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCotatoCharacterDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 226,
    viewBox: "0 0 289 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5942 25.2383H139.953V33.2344H149.64V49.2267H158.817L158.817 80.2118H169.014V100.202H179.211V140.183H169.014V165.171H158.817L158.817 173.167H149.64V181.163H139.953V181.251H139.349V189.401L50.469 189.401V181.251H40.5942V173.101H30.72V33.3877H40.5942V25.2383ZM20.8419 49.6884H30.7168V148.652H20.8419V49.6884ZM20.8407 78.7955H10.9658V140.502H20.8407V78.7955ZM60.3431 189.402V197.551L129.472 197.551V189.402H60.3431Z",
    fill: "#D59F52"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 127.211,
    y: 68.2168,
    width: 17.3345,
    height: 35.9827,
    fill: "#1A1918"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 135.368,
    y: 72.2148,
    width: 9.17707,
    height: 12.9938,
    fill: "#F7F4F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.278 0.25H61.4354V8.39994H119.278V0.25Z",
    fill: "#1A1918"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.154 197.155H60.0246V205.163H129.154V197.155Z",
    fill: "#1A1918"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7155 16.2423H40.5385V25.238H50.1491L49.7155 16.2423Z",
    fill: "#1A1918"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.154 16.5499H139.029V25.238H129.154V16.5499Z",
    fill: "#1A1918"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.278 8.39994H129.154V16.5499H119.278V8.39994Z",
    fill: "#1A1918"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7155 8.39994H61.4354V16.5499L49.7155 16.2423V8.39994Z",
    fill: "#1A1918"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5385 25.238H30.3979V33.2341H40.5385V25.238Z",
    fill: "#1A1918"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.029 25.238H148.905V33.2341H139.029V25.238Z",
    fill: "#1A1918"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3979 33.2341H20.5223V49.1496H30.3979V33.2341Z",
    fill: "#1A1918"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5223 49.1496H10.6467V78.2566H20.5223V49.1496Z",
    fill: "#1A1918"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148.905 33.2341H158.78V49.2265H148.905V33.2341Z",
    fill: "#1A1918"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6467 78.2566H0.771133V139.963H10.6467V78.2566Z",
    fill: "#1A1918"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M169.017 49.2265H158.78V80.5851H169.017V49.2265Z",
    fill: "#1A1918"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3979 148.113H20.5223V172.167H30.3979V148.113Z",
    fill: "#1A1918"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M169.017 139.963H179.214V164.171H169.017V139.963Z",
    fill: "#1A1918"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M169.017 80.5851H179.214V100.378H169.017V80.5851Z",
    fill: "#1A1918"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2735 172.167H30.3979V180.713H40.2735V172.167Z",
    fill: "#1A1918"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5223 139.963H10.6467V148.113H20.5223V139.963Z",
    fill: "#1A1918"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M149.644 173.167H158.78V181.163H149.644V173.167Z",
    fill: "#1A1918"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M158.78 164.171H169.017V173.167H158.78V164.171Z",
    fill: "#1A1918"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7155 180.713H40.2735V189.159H49.7155V180.713Z",
    fill: "#1A1918"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M139.447 181.163H149.644V189.159H139.447V181.163Z",
    fill: "#1A1918"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0246 189.159H49.7155V197.155H60.0246V189.159Z",
    fill: "#1A1918"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M129.154 189.159H139.447V197.155H129.154V189.159Z",
    fill: "#1A1918"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M188.407 100.378H179.214V139.963H188.407V100.378Z",
    fill: "#1A1918"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61.9521,
    y: 68.2168,
    width: 17.3345,
    height: 35.9827,
    fill: "#1A1918"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70.1094,
    y: 72.2148,
    width: 9.17707,
    height: 12.9938,
    fill: "#F7F4F0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 7.78573,
    height: 9.34288,
    transform: "matrix(-1 0 0 1 90.3076 114.701)",
    fill: "#1A1918"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7.00716,
    height: 8.5643,
    transform: "matrix(-1 0 0 1 125.343 115.479)",
    fill: "#1A1918"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 28.3894,
    height: 7.25954,
    transform: "matrix(-1 0 0 1 79.7686 206.199)",
    fill: "#B17C31"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 24.4722,
    height: 6.99664,
    transform: "matrix(-1 0 0 1 142.506 206.15)",
    fill: "#B17C31"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 28.5509,
    height: 7.99615,
    transform: "matrix(-1 0 0 1 118.034 124.189)",
    fill: "#1A1918"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 28.5509,
    height: 8.99567,
    transform: "matrix(-1 0 0 1 79.2861 197.156)",
    fill: "#1A1918"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 27.5312,
    height: 8.99567,
    transform: "matrix(-1 0 0 1 79.2861 213.148)",
    fill: "#1A1918"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 26.5115,
    height: 8.99567,
    transform: "matrix(-1 0 0 1 144.546 213.148)",
    fill: "#1A1918"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.276 8.40039H61.4337V16.2423H49.7115V25.238H61.4384V32.849H112.227V25.238H129.246V16.2423H119.276V8.40039ZM96.709 32.8494H61.439V40.9993H96.709V32.8494Z",
    fill: "#EBBA77"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5364 25.2383H49.7134V70.2167H40.5364V25.2383ZM30.3369 33.2349H40.5337V148.116H50.1429V156.264H78.3592V164.414H88.2333V172.563H40.2662V172.168H30.3369V148.114H20.5166V49.1501H30.3369V33.2349ZM20.5154 78.2582H10.6405V139.965H20.5154V78.2582ZM98.1115 172.564V180.164H129.245L129.245 172.168H139.442V164.172H158.816V173.168H149.639V181.164H139.442V189.16L129.247 189.16V197.156H59.9095V189.16L49.7107 189.16L49.7107 180.714H40.2687V172.564H98.1115ZM169.013 164.172V156.176H139.442V164.172H169.013Z",
    fill: "#B17C31"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 8.1574,
    height: 24.988,
    transform: "matrix(-1 0 0 1 57.873 197.156)",
    fill: "#1A1918"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 8.1574,
    height: 23.9885,
    transform: "matrix(-1 0 0 1 81.3262 198.154)",
    fill: "#1A1918"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 7.13772,
    height: 24.988,
    transform: "matrix(-1 0 0 1 144.546 197.156)",
    fill: "#1A1918"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 7.13772,
    height: 23.9885,
    transform: "matrix(-1 0 0 1 125.172 198.154)",
    fill: "#1A1918"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 26.5115,
    height: 8.99567,
    transform: "matrix(-1 0 0 1 144.546 197.156)",
    fill: "#1A1918"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 45.1504,
    y: 110.029,
    width: 20.2429,
    height: 9.34288,
    fill: "url(#paint0_linear_9533_24102)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 140.136,
    y: 110.029,
    width: 20.2429,
    height: 9.34288,
    fill: "url(#paint1_linear_9533_24102)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 25.8142,
    height: 9.11309,
    transform: "matrix(-1 0 0 1 93.3789 154.16)",
    fill: "#1A1918"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 6.94997,
    height: 25.3141,
    transform: "matrix(-1 0 0 1 93.3789 137.959)",
    fill: "#1A1918"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 6.94997,
    height: 24.3016,
    transform: "matrix(-1 0 0 1 74.5146 138.971)",
    fill: "#1A1918"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 25.8142,
    height: 9.11309,
    transform: "matrix(-1 0 0 1 93.3789 137.959)",
    fill: "#1A1918"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M177.191 203.464L255.922 189.679L155.318 132.608L71.1756 139.103L177.191 203.464Z",
    fill: "#4E4C49"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M182.81 65.585L250.113 100.093L248.859 107.066L181.646 72.0601L182.81 65.585Z",
    fill: "#6A6966"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M181.606 72.1866L248.819 107.193L247.655 113.668L180.352 79.1597L181.606 72.1866Z",
    fill: "#242321"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.041 95.0421L256.676 102.748L270.576 109.929L256.667 188.433L256.312 188.236L255.941 190.322L251.38 187.803L255.683 190.596L189.044 201.414L189.57 201.728L177.285 203.588L71.0957 139.208L71.6032 139.164L71.299 138.982L151.298 131.686L164.707 56.0065L176.074 62.1977L177.439 54.4917L258.041 95.0421ZM91.1556 142.9L158.859 136.725L247.84 185.849L180.775 196.471L91.1556 142.9ZM243.804 175.395L250.725 179.151L262.474 112.84L255.481 109.491L243.804 175.395ZM158.278 128.992L163.716 131.943L174.794 69.4219L169.35 66.5006L158.278 128.992ZM249.512 100.362L239.101 159.119L172.997 122.379L182.896 66.5107L249.512 100.362ZM170.779 134.901L236.968 171.16L237.907 165.862L171.803 129.121L170.779 134.901Z",
    fill: "#242321"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M182.649 65.5843L250.114 100.165L237.317 171.438L170.083 135.57L182.649 65.5843Z",
    fill: "#8F8D89"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M216.505 123.178L204.915 115.846L206.106 119.483L207.744 125.762L205.517 127.892L202.399 129.852L214.137 136.36L216.505 123.178Z",
    fill: "#F7F4F0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M214.42 114.256L210.259 111.756L209.667 115.051L213.828 117.552L214.42 114.256Z",
    fill: "#F7F4F0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M262.46 112.652L243.012 102.588L231.142 168.55L250.694 179.71L262.46 112.652Z",
    fill: "#8F8D89"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M183.908 73.4551L169.444 66.4293L156.876 129.104L172.471 136.955L183.908 73.4551Z",
    fill: "#8F8D89"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 190.516,
    y: 39.957,
    width: 4.44352,
    height: 4.44352,
    transform: "rotate(45 190.516 39.957)",
    fill: "url(#paint2_linear_9533_24102)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 4.44352,
    height: 4.44352,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 256.171 209.686)",
    fill: "url(#paint3_linear_9533_24102)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 204.53,
    y: 46.1855,
    width: 8.48651,
    height: 8.48651,
    transform: "rotate(45 204.53 46.1855)",
    fill: "url(#paint4_linear_9533_24102)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 8.48651,
    height: 8.48651,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 242.68 201.9)",
    fill: "url(#paint5_linear_9533_24102)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 16.3585,
    height: 16.3585,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 277.055 179.322)",
    fill: "url(#paint6_linear_9533_24102)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9533_24102",
    x1: 55.2718,
    y1: 110.029,
    x2: 55.2718,
    y2: 119.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA4CD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9533_24102",
    x1: 150.257,
    y1: 110.029,
    x2: 150.257,
    y2: 119.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA4CD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9533_24102",
    x1: 192.737,
    y1: 39.957,
    x2: 192.737,
    y2: 44.4006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA4CD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9533_24102",
    x1: 2.22176,
    y1: 0,
    x2: 2.22176,
    y2: 4.44352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA4CD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9533_24102",
    x1: 208.774,
    y1: 46.1855,
    x2: 208.774,
    y2: 54.6721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA4CD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9533_24102",
    x1: 4.24325,
    y1: 0,
    x2: 4.24325,
    y2: 8.48651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA4CD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9533_24102",
    x1: 8.17925,
    y1: 0,
    x2: 8.17925,
    y2: 16.3585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA4CD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCotatoCharacterDesign);
export default __webpack_public_path__ + "static/media/cotato_character_design.15cac642215715e1be4a78f883927ffd.svg";
export { ForwardRef as ReactComponent };